module.exports = __webpack_public_path__ + "img/d.b0d89158.jpg";